import { render, staticRenderFns } from "./Senders.vue?vue&type=template&id=2bf1f369&scoped=true&"
import script from "./Senders.vue?vue&type=script&lang=js&"
export * from "./Senders.vue?vue&type=script&lang=js&"
import style0 from "./Senders.vue?vue&type=style&index=0&id=2bf1f369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1f369",
  null
  
)

export default component.exports